import { render, staticRenderFns } from "./Trp.vue?vue&type=template&id=50ce952e&"
import script from "./Trp.vue?vue&type=script&lang=js&"
export * from "./Trp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports